import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActionState } from 'src/app/enums/action-state.enum';
import { CoreEnum } from 'src/app/enums/core.enum';
import { UserRepo } from 'src/app/repositories/user-repo';
import { VehicleRepo } from 'src/app/repositories/vehicle-repo';

@Component({
    selector: 'app-modal-subscription-assignment',
    templateUrl: './modal-subscription-assignment.component.html',
    styleUrls: ['./modal-subscription-assignment.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalSubscriptionAssignmentComponent implements OnDestroy {
  destroyed$ = new Subject<void>();
  loadingState = new BehaviorSubject(ActionState.READY);
  actionState = ActionState;
  error: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userRepo: UserRepo,
    private vehicleRepo: VehicleRepo
  ) {}

  subscribeUserToPlan(uid: string) {
    if (this.data.type === CoreEnum.USER_SUBSCRIPTION) {
      this.loadingState.next(ActionState.LOADING);
      this.userRepo
        .subscribeUserToDefaultPlan(uid)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (res) => {
            this.loadingState.next(ActionState.SUCCESS);
          },
          error: (error) => {
            this.loadingState.next(ActionState.FAILED);
            this.error = error.error;
          },
        });
    }

    if (this.data.type === CoreEnum.VEHICLE_SUBSCRIPTION) {
      this.loadingState.next(ActionState.LOADING);
      this.vehicleRepo
        .subscribeVehicleToDefaultPlan(uid)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (res) => {
            this.loadingState.next(ActionState.SUCCESS);
          },
          error: (error) => {
            this.loadingState.next(ActionState.FAILED);
            this.error = error.error;
          },
        });
    }
  }

  onSubmit() {
    const userUid = this.data.userObj.uid;
    this.subscribeUserToPlan(userUid);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
